<template>
  <div id="Index">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "Index"
};
</script>
<style lang="stylus" scoped>
#Index {
  width: 1080px;  
  margin: 0 auto !important; 
  padding:46px 0px;
}

@media screen and (max-width: 1080px) {
  #Index {
    width: 100%;
    margin: 0 auto !important;  
    padding:46px 0px 0px 0px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Index.vue